'use strict';

export default class collectionEditor {
    constructor(options, preventDelete = false) {

        this.opt = options;
        this.preventDelete = preventDelete;
        this.addDateEventsSwitcher = typeof options.addDateEventsSwitcher !== 'undefined' ? options.addDateEventsSwitcher : true;

        this.bindHandlers();
    }

    addMultiItemForm($collectionHolder, $newLinkLi) {
        // Get the data-prototype explained earlier
        var prototype = $collectionHolder.data('prototype');

        // get the new index
        var index = $collectionHolder.data('index');

        var newForm = prototype;
        // You need this only if you didn't set 'label' => false in your item field in ...Type
        // Replace '__name__label__' in the prototype's HTML to
        // instead be a number based on how many items we have
        // newForm = newForm.replace(/__name__label__/g, index);

        // Replace '__name__' in the prototype's HTML to
        // instead be a number based on how many items we have
        newForm = newForm.replace(/__name__/g, index);

        // increase the index with one for the next item
        $collectionHolder.data('index', index + 1);

        // Display the form in the page in an li, before the "Add new item" link li
        var $newFormLi = $('<li></li>').append(newForm);
        $newLinkLi.before($newFormLi);
        this.addItemFormDeleteLink($newFormLi);
    }

    addItemFormDeleteLink($itemFormLi) {

        var self = this;

        var $removeFormButton = $('<button type="button" class="btn delete-collection-item">'+this.opt.deleteButtonText+'</button>');
        $itemFormLi.append($removeFormButton);

        $removeFormButton.on('click', function(e) {
            // remove the li for the item form

            if (self.preventDelete === true) {
                var itemsInWrapper = $(this).closest('ul').find('.delete-collection-item').length;
                if (itemsInWrapper < 2) {
                    return false;
                }
            }

            $itemFormLi.remove();
        });
    }
    bindHandlers ()
    {
        var self = this;

        // setup an "add an item" link
        var $addNewItemButton = $('<span class="btn-text add-new-element-btn">'+this.opt.newItemButtonText+'</span>');

        var $newLinkLiLIW = $('<li></li>').append($addNewItemButton);


        // Get the ul that holds the collection of items
        let $collectionHolder = this.opt.$collectionHolder;

        // add a delete link to all of the existing item form li elements
        $collectionHolder.find('li').each(function() {
            self.addItemFormDeleteLink($(this));
        });

        // add the "add item" anchor and li to the items ul
        $collectionHolder.append($newLinkLiLIW);

        // count the current form inputs we have (e.g. 2), use that as the new
        // index when inserting a new item (e.g. 2)
        $collectionHolder.data('index', $collectionHolder.find(':input').length);

        if (self.addDateEventsSwitcher) {
            this.addDateEvents();
        }

        $addNewItemButton.on('click', function() {
            // add a new item form
            self.addMultiItemForm($collectionHolder, $newLinkLiLIW);
            // init select2 for elements
            $collectionHolder.find('.select2-select').select2({
                language: self.opt.locale
            });

            self.addDateEvents();
        });
    }

    addDateEvents() {
        let isMobile = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (isMobile) {
            moment.locale(this.opt.locale);
            $('.date').combodate({
                format: "MM-YYYY",
                template: "MMMM YYYY",
                minYear: 1950,
                maxYear: 2019,
                smartDays: true
            });
        } else {
            $('.date').datepicker({
                format: 'mm-yyyy',
                clearBtn: true,
                startView: 2,
                endDate: new Date().toTimeString(),
                minViewMode: 1,
                maxViewMode: 2,
                language: this.opt.locale,
                defaultViewDate: { year: 2010 },
                toggleActive: true,
                autoclose: true
            });
        }
    }
}